// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 1,
  argument: "The use and end of the proverbs. An exhortation to flee the company of the wicked: and to hearken to the voice of wisdom.",
  verses: [
    { n: 1, text: "The parables of Solomon, the son of David, king of Israel," },
    { n: 2, text: "To know wisdom, and instruction:" },
    { n: 3, text: "To understand the words of prudence: and to receive the instruction of doctrine, justice, and judgment, and equity:" },
    { n: 4, text: "To give subtilty to little ones, to the young man knowledge and understanding." },
    { n: 5, text: "A wise man shall hear and shall be wiser: and he that understandeth shall possess governments." },
    { n: 6, text: "He shall understand a parable, and the interpretation, the words of the wise, and their mysterious sayings." },
    { n: 7, text: "The fear of the Lord is the beginning of wisdom. Fools despise wisdom and instruction." },
    { n: 8, text: "My son, hear the instruction of thy father, and forsake not the law of thy mother:" },
    { n: 9, text: "That grace may be added to thy head, and a chain of gold to thy neck." },
    { n: 10, text: "My son, if sinners shall entice thee, consent not to them." },
    { n: 11, text: "If they shall say: Come with us, let us lie in wait for blood, let us hide snares for the innocent without cause:" },
    { n: 12, text: "Let us swallow him up alive like hell, and whole as one that goeth down into the pit." },
    { n: 13, text: "We shall find all precious substance, we shall fill our houses with spoils." },
    { n: 14, text: "Cast in thy lot with us, let us all have one purse." },
    { n: 15, text: "My son, walk not thou with them, restrain thy foot from their paths." },
    { n: 16, text: "For their feet run to evil, and make haste to shed blood." },
    { n: 17, text: "But a net is spread in vain before the eyes of them that have wings." },
    { n: 18, text: "And they themselves lie in wait for their own blood, and practise deceits against their own souls." },
    { n: 19, text: "So the ways of every covetous man destroy the souls of the possessors." },
    { n: 20, text: "Wisdom preacheth abroad, she uttereth her voice in the streets:" },
    { n: 21, text: "At the head of multitudes she crieth out, in the entrance of the gates of the city she uttereth her words, saying:" },
    { n: 22, text: "O children, how long will you love childishness, and fools covet those things which are hurtful to themselves, and the unwise hate knowledge?" },
    { n: 23, text: "Turn ye at my reproof: behold I will utter my spirit to you, and will shew you my words." },
    { n: 24, text: "Because I called, and you refused: I stretched out my hand, and there was none that regarded." },
    { n: 25, text: "You have despised all my counsel, and have neglected my reprehensions." },
    { n: 26, text: "I also will laugh in your destruction, and will mock when that shall come to you which you feared." },
    { n: 27, text: "When sudden calamity shall fall on you, and destruction, as a tempest, shall be at hand: when tribulation and distress shall come upon you:" },
    { n: 28, text: "Then shall they call upon me, and I will not hear: they shall rise in the morning, and shall not find me:" },
    { n: 29, text: "Because they have hated instruction, and received not the fear of the Lord," },
    { n: 30, text: "Nor consented to my counsel, but despised all my reproof." },
    { n: 31, text: "Therefore they shall eat the fruit of their own way, and shall be filled with their own devices." },
    { n: 32, text: "The turning away of little ones shall kill them, and the prosperity of fools shall destroy them." },
    { n: 33, text: "But he that shall hear me, shall rest without terror, and shall enjoy abundance, without fear of evils." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Israel. The dignity of the author, and the importance of the subject, invite us to read. (St. Basil) — Solomon is the first whose name is placed at the head of any work in Scripture.", attribution: "Calmet" }
    ] },
    { verse: 2, notes: [
      { text: "To know. This is the design of these parables. (Calmet) — They tend to instruct both the unexperienced and the wise,", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "There are three sorts of wisdom: the divine, which is God himself; (chap. iii. 16.) the supernatural, which is his gift, to lead us into all virtue; and the worldly, which is mixed with error, &c. (Worthington)", attribution: "Wisdom vii. 25." }
    ] },
    { verse: 4, notes: [
      { text: "Subtilty. Discretion to the innocent.", attribution: "Calmet" }
    ] },
    { verse: 6, notes: [
      { text: "Sayings. This science was much esteemed, 3 Kings x. l., and Ecclesiasticus xxxix. 2.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Fear. Thus we arrive at charity. (St. Augustine, in ep. Jo. ix.; Job xxviii. 28., &c.) This fear includes religion, but not barren speculations. (Calmet) — It implies a desire to act, and not simply to understand.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Mother. The first precept is to learn of our elders, and the second to resist evil counsels,", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "(Worthington) — Our parents have the greatest influence over us. Solomon presupposes that they are virtuous and well informed.", attribution: "Calmet" }
    ] },
    { verse: 12, notes: [
      { text: "Pit. Grave, or hell, like Dathan, Numbers xvi. This shews the greatest rage, Job xxxi. 31.", attribution: "Haydock" }
    ] },
    { verse: 17, notes: [
      { text: "Wings. If thou attend, therefore, to my instructions, their arts will be vain. (Ven. Bede) — They unjustly seek to deceive the pious. (Calmet) — Watchfulness will be the best protection against them.", attribution: "Worthington" }
    ] },
    { verse: 19, notes: [
      { text: "Possessors. Of money. (Calmet) — While they attempt to invade another's property, they ruin themselves, and come to the gallows.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Streets. In every place we may learn wisdom. \"The wise learn more from fools, than fools do from the wise,\" as Cato well observed.", attribution: "Calmet" }
    ] },
    { verse: 22, notes: [
      { text: "Fools. Hebrew, \"and scorners delight in their scorning.\" (Protestants) — Such are the pests of society. (Haydock) — They turn piety to ridicule, and will talk about things which they do not understand, like our esprits forts, (Calmet) or pretended philosophers.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Mock. God is too much above us to act thus; but he will treat us as an enraged enemy. (Calmet) — In hell, the damned will cry in vain,", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "They had sufficient graces offered while they were alive.", attribution: "Worthington" }
    ] },
    { verse: 30, notes: [
      { text: "Despised. Literally, \"detracted,\" (Haydock) supposing my threats would not be put in execution. Hebrew, \"they abhorred.\"", attribution: "Calmet" }
    ] },
    { verse: 32, notes: [
      { text: "Turning. Hebrew, \"the ease of the simple,\" who have given way to deceit. (Calmet) — Them. The objects of their eager desires, prove their ruin, Ezechiel xvi. 49.", attribution: "Haydock" }
    ] },
    { verse: 33, notes: [
      { text: "Evils. Both the just and the wicked, (", attribution: "Haydock" }
    ] },
    { verse: 31, notes: [
      { text: "; Haydock) shall be treated according to their deserts, 2 Corinthians v. 10. (Worthington) — Even in this world, the just enjoy the peace of a good conscience.", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
